module.exports = __webpack_public_path__ + "img/0Q3A4612_L_BlackMatted_MockedUp.300b85d8.jpg";